import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { DateRangeType, IgxCalendarComponent } from 'igniteui-angular';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-date-piker',
  templateUrl: './date-piker.page.html',
  styleUrls: ['./date-piker.page.scss'],
})
export class DatePikerPage implements OnInit {
  selectedDate: any;
  startDateselect: any;
  calenderType: String;
  @ViewChild('calendar', { static: true }) public calendar: IgxCalendarComponent;
  @ViewChild('prevMonthBtn')
  public prevMonthBtn: ElementRef;

  // @ViewChild('calendar', { read: IgxCalendarComponent }) public calendar: IgxCalendarComponent;
  // @ViewChild('calendar') public calendar: IgxCalendarComponent;
  range: any;
  curdate: any;
  dateFromNurse: any;
  messageFromNurse :any;
  disabled:any;
  cheat_days_list:any;
  diet_from_date:any;

  constructor(public ModelCtrl: ModalController,
    public addCall: AddCall,
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    debugger;
    console.log(this.curdate, "check dateformate ");

    //this.selectedDate = localStorage.getItem("selectedDate");
    console.log("From Type = ", this.calenderType)
    if (this.calenderType == "dob") {
      let date1 = new Date();
      let date2 = new Date("3000-01-01");
      //date2.setDate(date2.getDate() - 1);
      this.range = [date1, date2];
      this.calendar.disabledDates = [{ type: DateRangeType.Between, dateRange: this.range }];
    } else if (this.calenderType == "docList") {
      let date = new Date();
      date.setDate(date.getDate() - 1);
      let date1 = date;
      console.log("Range to - ", date1);
      let date2 = new Date("0001-01-01");
      this.range = [date1, date2];
      this.calendar.disabledDates = [{ type: DateRangeType.Between, dateRange: this.range }];
    } else if (this.calenderType == "normal") {
      debugger;
      let date1 = new Date(1);
      let date2 = new Date();
      console.log(this.disabled);
      date2.setDate(date2.getDate() - 1);
      this.range = [date1, date2];
      this.calendar.disabledDates = [{ type: DateRangeType.Between, dateRange: this.range }];
    } else if (this.calenderType == "normalToDate") {
      let date1 = new Date(1);
      let date2 = this.selectedDate;
      console.log(this.disabled);
      date2.setDate(date2.getDate() - 1);
      this.range = [date1, date2];
      this.calendar.disabledDates = [{ type: DateRangeType.Between, dateRange: this.range }];
    }
    else if (this.calenderType == "dietnormal") {
      debugger;
      let date1 = new Date(1);
      let date2 = new Date();
      console.log(this.disabled);
      if(this.cheat_days_list != ""){

        let date = new Date(this.diet_from_date);
        while (this.isCheatDay(date)) {
          date.setDate(date.getDate() + 1);
          }
          this.startDateselect = date;
      }
      if (this.disabled!="") {
        this.selectedDate = this.startDateselect;
        date2 = new Date(this.disabled);
        date2.setDate(date2.getDate() - 1);
        this.eventHandler(this.startDateselect);
      }else{
        date2.setDate(date2.getDate() - 1);
      }
      
      this.range = [date1, date2];
      this.calendar.disabledDates = [{ type: DateRangeType.Between, dateRange: this.range }];

    } else if (this.calenderType == "to") {
      let date1 = new Date();
      let date2 = new Date("3000-01-01");
      date1.setDate(date1.getDate() + 1);
      
      this.range = [date1, date2];
      this.calendar.disabledDates = [{ type: DateRangeType.Between, dateRange: this.range }];
    }

  }

  SetDate() {
    debugger
    console.log("selectedDate=>", this.selectedDate);
    // if(this.calenderType == "dietnormal" && this.cheat_days_list != ""){
    //   let date = new Date(this.selectedDate);
    //   while (this.isCheatDay(date)) {
    //     date.setDate(date.getDate() + 1);
    //     }
    //     this.selectedDate = date;

    // }

    let getDate = new Date();
    let currentDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + getDate.getDate()).slice(-2);
    console.log("thinmsdsdds", currentDate);

    let getDateof = new Date(this.selectedDate);
    let currentDateforCheck = getDateof.getFullYear() + "-" + ("0" + (getDateof.getMonth() + 1)).slice(-2) + "-" + ("0" + getDateof.getDate()).slice(-2);
    console.log("podadei", currentDateforCheck);

    if (currentDate == currentDateforCheck && this.messageFromNurse == "nurseDateof" ) {
      console.log("cannot book on the current date")
    } else {
      this.ModelCtrl.dismiss(this.selectedDate);
    }




    console.log("selectedDate2=>", this.selectedDate);
    console.log("dateNurse", this.dateFromNurse);


  }
  cancelDate() {
    console.log("search Date=>", this.selectedDate);
    this.ModelCtrl.dismiss();
  }
  isCheatDay(date) {
    let Days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let Daysinarabic = [
      'الأحد',
      'الاثنين',
      'الثلاثاء',
      'الأربعاء',
      'الخميس',
      'الجمعة',
      'السبت',
    ];
    let day = date.getDay();
    let dayName = Days[day];
    let dayNameinarabic = Daysinarabic[day];
    return this.cheat_days_list.some(
      (x) => x.value == dayName || x.value == dayNameinarabic
    );
  }

  eventHandler(event) {
    debugger;
    console.log(new Date(event), "selected date");
    this.curdate = new Date(event).toString().split(' ')[0] + ", " + new Date(event).toString().split(' ')[1] + " " + new Date(event).toString().split(' ')[2]
console.log("datevalue",this.curdate)
  }
}
